import React from "react";
import { NavLink } from "react-router-dom";

const SidebarItem = ({ to, tag: Tag, children, ...rest }) => {
  return (
    <li className="nav-item " style={{width:'100%'}}>
      <Tag  className="nav-link" to={to}  {...rest}>
      <span class="sidenav-mini-icon">A </span>
      <span className="sidenav-normal">  {children} </span>
      </Tag>
    </li>
  );
};

export default SidebarItem;
